export default {
  table: {
    name: "角色名称",
    remark: "备注",
    createBy: "添加人",
    updateBy: "修改人",
    createAt: "创建时间",
    updatedAt: "修改时间",
    menuPermissions: "菜单权限",
    isAdministrator: "是否是管理员",
  },
  form: {
    name: "角色",
    administrator: "管理员",
  },
};
